import { IonButton, useIonAlert } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { assignOrganizations } from "../../../store/userProfileOrganization/actions/assignOrganizations";
import { selectOrganizationSelectedCounter } from "../../../store/userProfileOrganization/selectors/selectOrganizationSelectedCounter"

export const ConfirmButton = () => {
  const dispatch = useDispatch();
  const [present] = useIonAlert();
  const selectedOrganizationCounter = useSelector(selectOrganizationSelectedCounter);

  const onSubmit = async () => {
    dispatch(assignOrganizations());
  };

  return (
    <>
      <IonButton
        fill="solid"
        size="large"
        color="secondary"
        onClick={() => {
          present({
            header: `¿Deseas asignar ${selectedOrganizationCounter} ${
              selectedOrganizationCounter === 1 ? "cliente" : "clientes"
            }?`,
            buttons: [
              "No",
              {
                text: `Asignar ${selectedOrganizationCounter} ${
                    selectedOrganizationCounter === 1 ? "cliente" : "clientes"
                }`,
                handler: () => onSubmit(),
              },
            ],
          });
        }}
      >
        Guardar
      </IonButton>
    </>
  );
};